import { cloneDeep } from 'lodash';
import BaseDropdown from './dropdown';
import { getSelectedString } from '../common/utils';

class PricingModelDropdown extends BaseDropdown {
  constructor(props) {
    super(props);

    this.type = 'pricingModels';
    this.label = 'Pricing Models';
    this.identifierField = 'label';
    this.dropdownDiv = null;
    this.hasSearch = false;

    this.state = {
      opened: false,
      focusIndex: null,
      pricingModels: this.props.items,
    };
  }

  update() {
    const newItems = cloneDeep(this.state.pricingModels);

    if (!newItems.find(item => item.selected)) {
      newItems.map(item => (item.selected = true));
    }
    this.setState({ pricingModels: newItems });
    const selectedItems = getSelectedString(newItems);
    this.AnalyticService.trackEvent(
      this.props.gaEvent.category,
      'Execute',
      `${this.props.gaEvent.label} ${selectedItems}`,
    );

    // Update base-overview with new items
    this.props.updatePricingModelOptions(newItems);
  }
}

export default PricingModelDropdown;
